<template src="./login-initial.html"></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'

export default {
  name: 'login-initial',
  data () {
    return {
      loading: false,
      tabs: null,
      user: {
        login: '',
        password: ''
      },
      emailRules: [
        v => !!v || this.$t('validation.emailRequired'),
        v => /.+@.+\..+/.test(v) || this.$t('validation.emailRequired')
      ]
    }
  },
  methods: {
    initialLogin () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.loading = true
      this.logConsole('Sending initial login request')
      this.$http.post(Vue.$apiConfig.activateRegisteredSystemUserPost, this.user)
        .then(response => {
          this.logConsole(response)
          this.loading = false
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('activation.activationSent'),
            errors: []
          })
        }, error => {
          this.logConsole(error)
          this.loading = false
          this.formatErrorResponse(error)
        })
    }
  }
}
</script>
